import { useEffect, useState } from "react"
import { Button } from "../../components/ui/button"
import { Input } from "../../components/ui/input"
import { Label } from "../../components/ui/label"
import { smsApi } from "../../services/smsApi"

export default function ReviewUrlSettings() {
  const [reviewUrl, setReviewUrl] = useState("")
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState("")
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const response = await smsApi.getReviewUrl()
        setReviewUrl(response.review_url || "")
      } catch (error) {
        setIsError(true)
        setMessage(error instanceof Error ? error.message : "Could not load the review URL.")
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])

  const handleSave = async () => {
    setSaving(true)
    setMessage("")
    setIsError(false)
    try {
      const response = await smsApi.updateReviewUrl(reviewUrl.trim())
      setReviewUrl(response.review_url)
      setMessage("Review URL saved. The next Review Request SMS will use it.")
    } catch (error) {
      setIsError(true)
      setMessage(error instanceof Error ? error.message : "Could not save the review URL.")
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="mx-auto max-w-xl p-6">
      <h1 className="text-xl font-semibold text-slate-900">SMS settings</h1>
      <p className="mt-1 text-sm text-slate-600">
        The Review Request template inserts this link. Leave it blank until the review URL exists.
      </p>
      <div className="mt-6 space-y-2">
        <Label htmlFor="review-url">Review URL</Label>
        <Input
          id="review-url"
          value={reviewUrl}
          onChange={(event) => setReviewUrl(event.target.value)}
          placeholder="https://"
          disabled={loading || saving}
        />
      </div>
      <Button className="mt-4" onClick={handleSave} disabled={loading || saving}>
        {saving ? "Saving..." : "Save"}
      </Button>
      {message && (
        <p className={`mt-3 text-sm ${isError ? "text-red-600" : "text-slate-700"}`}>{message}</p>
      )}
    </div>
  )
}
